import React, { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import Loader from "./Loader";
import Error from "../pages/error";
import { useAppContext } from "../context/AppContext";
import { ValidateApp } from "../network/api/ValidateApp";
import { useLocation } from "react-router-dom";
import Transition from "./Transition";
import { AnimatePresence } from "framer-motion";


export default function AppWrapper() {
    const appName = process.env.REACT_APP_APP_NAME || null;
    const { setAppData } = useAppContext();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const location = useLocation();
    const initAttemptRef = useRef(0);
    const initTimerRef = useRef(null);
    const animationFrameRef = useRef(null);

    navigator.geolocation.getCurrentPosition(() => {});

    useEffect(() => {
        if (isLoading) {
            return undefined;
        }

        let isCancelled = false;
        initAttemptRef.current = 0;

        const clearPendingInit = () => {
            if (initTimerRef.current) {
                window.clearTimeout(initTimerRef.current);
                initTimerRef.current = null;
            }

            if (animationFrameRef.current) {
                window.cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }
        };

        const hasTemplateShell = () => {
            return Boolean(
                document.querySelector("#main-wrapper") ||
                document.querySelector(".nav-control") ||
                document.querySelector(".dz-theme-mode") ||
                document.querySelector("#menu")
            );
        };

        const initializeTemplateUI = () => {
            if (isCancelled) {
                return;
            }

            const initFn = window.initTemplateScripts;
            const canInitialize = typeof initFn === "function";
            const shellReady = hasTemplateShell();
            const maxAttempts = 12;

            if (!canInitialize || (!shellReady && initAttemptRef.current < maxAttempts)) {
                initAttemptRef.current += 1;
                initTimerRef.current = window.setTimeout(() => {
                    animationFrameRef.current = window.requestAnimationFrame(initializeTemplateUI);
                }, 150);
                return;
            }

            initFn();

            if (window.innap?.resize) {
                window.innap.resize();
            }

            if (window.innap?.handleMenuPosition) {
                window.setTimeout(() => {
                    if (!isCancelled) {
                        window.innap.handleMenuPosition();
                    }
                }, 100);
            } else {
                window.dispatchEvent(new Event("resize"));
            }
        };

        animationFrameRef.current = window.requestAnimationFrame(() => {
            animationFrameRef.current = window.requestAnimationFrame(initializeTemplateUI);
        });

        return () => {
            isCancelled = true;
            clearPendingInit();
        };
    }, [location.key, location.pathname, isLoading]);

    useEffect(() => {
        setIsLoading(true);
        const validateAndSetAppName = async () => {
            const response = await ValidateApp(appName);

            if (response.status === "success" && response.data) {
                setAppData(response.data);
                setIsLoading(false);
            } else {
                setError("Invalid app name");
                setIsLoading(false);
            }
        };

        validateAndSetAppName();
    }, [appName, setAppData]);
    
    if (isLoading) {
        return (
            <div className="app-preloader" aria-busy="true">
                <Loader />
            </div>
        );
    }

    if (error) {
        return (
            <div className="authincation h-100">
                <Error
                    code={500}
                    message="Internal server error!"
                />
            </div>
        );
    }

    return (
        <AnimatePresence mode="wait">
            <React.Fragment key={location.key}>
                <Transition>
                    <Outlet />
                </Transition>
            </React.Fragment>
        </AnimatePresence>
    );

}
